import { render, staticRenderFns } from "./MessageTip.vue?vue&type=template&id=4913c968&scoped=true"
import script from "./MessageTip.vue?vue&type=script&lang=js"
export * from "./MessageTip.vue?vue&type=script&lang=js"
import style0 from "./MessageTip.vue?vue&type=style&index=0&id=4913c968&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4913c968",
  null
  
)

export default component.exports